<template>
  <div class="body__form--subscription">
    <div class="subscription__section">
      <div class="hide__subscription-section">
        <div class="card">
          <div class="card-body">
            <div class="step__voyage">
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 1 || step === 2 ? 'custom__badge--active' : ''"
                >
                  1
                </div>
                <div
                  class="badge__text"
                  :class="step === 1 || step === 2 ? 'badge__text--active--active' : ''"
                >
                  Informations
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 3 ? 'custom__badge--active' : ''"
                >
                  2
                </div>
                <div
                  class="badge__text"
                  :class="step === 3 ? 'badge__text--active--active' : ''"
                >
                  Fichiers joints
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 4 ? 'custom__badge--active' : ''"
                >
                  3
                </div>
                <div
                  class="badge__text"
                  :class="step === 4 ? 'badge__text--active--active' : ''"
                >
                  Résultat
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-body">
            <div class="custom__badge-section d-md-none">
              <div
                class="custom__badge_default"
                :class="step === 1 || step === 2 ? 'custom__badge--active' : ''"
              >
                1
              </div>
              <div
                class="custom__badge_default"
                :class="step === 3 ? 'custom__badge--active' : ''"
              >
                2
              </div>
              <div
                class="custom__badge_default"
                :class="step === 4 ? 'custom__badge--active' : ''"
              >
                3
              </div>
            </div>
            <!-- debut ici -->
            <div class="row mb-2" v-if="step === 1">
              <div class="col-md-9 col-12">
                <div class="form-check">
                  <label
                    @click="changeType()"
                    class="form-check-label form__label"
                  >
                    <input
                      type="radio"
                      v-model="form.data.type_engin"
                      class="form-check-input"
                      value="1"
                      name="materiel"
                    />Véhicules à 4 roues
                  </label>
                  <label class="form-check-label ml-5 form__label">
                    <input
                      type="radio"
                      v-model="form.data.type_engin"
                      class="form-check-input"
                      value="2"
                      name="materiel"
                    />Véhicules à 2 ou 3 roues
                  </label>
                </div>
              </div>
            </div>

            <div v-if="['2', '3'].includes(node) && step === 1">
              <h4 class="mb-4">Informations clients</h4>
              <div class="form-row">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Nom du client</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.client_name"
                      type="text"
                      class="form-control"
                    />
                    <div v-if="errors.client_name" style="color: red">
                      {{ errors.client_name[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Prénom(s) du client</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.client_firstname"
                      type="text"
                      class="form-control"
                    />
                    <div v-if="errors.client_firstname" style="color: red">
                      {{ errors.client_firstname[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Numéro de téléphone</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.client_phone"
                      type="number"
                      min="0"
                      class="form-control"
                    />
                    <div v-if="errors.client_phone" style="color: red">
                      {{ errors.client_phone[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Email</label>
                    <input
                      v-model="form.data.client_email"
                      type="text"
                      class="form-control"
                    />
                    <div v-if="errors.client_email" style="color: red">
                      {{ errors.client_email[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin ici -->

            <h4 class="mb-4">{{ titleStep() }}</h4>
            <div v-if="step === 1">
              <div class="row">
                <div class="col-md-12 col-12" v-if="auth.profile == 2">
                  <div class="form-group">
                    <label class="form__label">Intermédiaire associé</label>
                    <select
                      v-model="form.data.sale_code"
                      @change="getSalePoint()"
                      class="form-control"
                      required
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in intermediaires"
                        :key="key"
                        :value="item.sale_code"
                      >
                        {{ item.nom_entreprise ? item.nom_entreprise : item.last_name + ' ' + item.first_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Type d’usage du véhicule</label>
                    <span class="required">*</span>
                    <select
                      @change="getPuissance()"
                      v-model="form.data.use_type"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in useTypes"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.use_type" style="color: red">
                      {{ errors.use_type[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Taille du cylindre</label>
                    <span class="required">*</span>
                    <select v-model="form.data.power_id" class="form-control">
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in puissance"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.power_id" style="color: red">
                      {{ errors.power_id[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Durée de l’abonnement</label>
                    <span class="required">*</span>
                    <select
                      v-model="form.data.duration_of_insurance"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in durations"
                        :key="key"
                        :value="item.slug"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.duration_of_insurance" style="color: red">
                      {{ errors.duration_of_insurance[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur vénale</label>
                    <input
                      v-model="form.data.valeur_venal"
                      type="number"
                      class="form-control"
                    />
                    <div v-if="errors.valeur_venal" style="color: red">
                      {{ errors.valeur_venal[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur neuve</label>
                    <input
                      v-model="form.data.valeur_neuve"
                      type="number"
                      class="form-control"
                    />
                    <div v-if="errors.valeur_neuve" style="color: red">
                      {{ errors.valeur_neuve[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Nombre de places</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.number_of_seats_in_the_vehicle"
                      type="number"
                      class="form-control"
                    />
                    <div
                      v-if="errors.number_of_seats_in_the_vehicle"
                      style="color: red"
                    >
                      {{ errors.number_of_seats_in_the_vehicle[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 2">
              <div class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold">Garanties</h6>
                </div>
              </div>
              <div
                class="row mb-2"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        :class="'garuanted1'"
                        type="checkbox"
                        :checked="true"
                        :disabled="true"
                      />
                      Responsabilité Civile
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      {{ form.data?.prc ? form.data.prc : '' }} F CFA
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row mb-2"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        :class="'garuanted1'"
                        type="checkbox"
                        :checked="true"
                        :disabled="true"
                      />
                      Individuelle conducteur
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      4200 F CFA
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row mb-2"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        :class="'garuanted2'"
                        @click="toggleGuarantee()"
                        type="checkbox"
                        :checked="form.data.contain_cedeao"
                      />
                      CEDEAO
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      2000 F CFA
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="step === 3">
              <p>
                Veuillez charger le(s) fichier(s) requis :
                <span style="color: #d09a12">copie de la carte grise.</span>
              </p>
              <file-upload
                ref="upload"
                :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
              />
            </div>
            <div v-if="step === 4">
              <div style="max-width: 70%" class="text-sm mb-2" v-if="auth.profile === 3">
                Pour offir une réduction au client entrez, le pourcentage de réduction dans le champ ci-dessous puis validez
              </div>
              <div class="detail__sup">
                <div class="row mb-2 d-flex align-items-center" v-if="auth.profile === 3">
                  <div class="col-md-8">
                    <input 
                      type="number" 
                      min="1" 
                      class="form-control form-control-sm"
                      placeholder="Entrez le % de réduction" 
                      v-model="pourcentageReduction"
                      :disabled="alreadyReduce"
                    />
                    <p class="mt-2">Si vous avez des questions ou rencontrez une difficulté, contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}</p>
                  </div>
                  <div class="col-md-4 my-md-0 my-3">
                    <button 
                      class="btn btn-primary btn-sm" 
                      @click="applyReduce()" 
                      :disabled="alreadyReduce"
                    >
                      Appliquer la réduction
                    </button>
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Prime nette</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.amount) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Avenant</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.avenant) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Frais de dossier</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.fees) }} FCFA
                  </div>
                </div>
                <div class="section__information mt-1">
                  <div class="section__information-text">Taxes</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.taxe) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__amount d-flex justify-content-between mt-2">
                  <div class="section__amount-text">Total</div>
                  <div class="section__amount-price">
                    {{ $format(summary.total) + " Fcfa" }}
                  </div>
                </div>
              </div>
              <div class="section__neg" v-if="node == '0'" @click="saveNegotiated()">
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                    fill="#002A85"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                    fill="#002A85"
                  />
                  <path
                    d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 9.50065 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 5.90588C9.96089 5.90588 10.334 6.27898 10.334 6.73922Z"
                    fill="#002A85"
                  />
                </svg>
                <span class="section__neg-text">Demander une négociation</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="button__footer">
              <button
                @click="prevStep()"
                :disabled="step === 1"
                class="btn btn-default__cancel mr-2"
              >
                Retour
              </button>
              <button
                :class="loading ? 'disabled' : ''"
                class="btn btn-primary__save"
                @click="saveAssurance()"
              >
                {{ getText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance auto n° {{ id }}
            </h5>
            <button
              type="button"
              class="close"
              @click="closeModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              :class="sending ? 'error' : ''"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api, apiV1 } from "../../../helpers/shared";
import FileUpload from "../../../components/upload/FileUpload.vue";
export default {
  components: { FileUpload },
  props: ["node"],
  name: "auto",
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    auth: {},
    pourcentageReduction: '',
    alreadyReduce: false,
    errors: [],
    intermediaires: [],
    step: 1,
    element: 0,
    loading: false,
    forfaits: [
      { id: 22, name: "Vol accessoires", price: 15750 },
      { id: 34, name: "Vol accessoires", price: 15750 },
      { id: 26, name: "Individuel conducteur (forfait de 1 000 000)", price: 2100 },
      { id: 38, name: "Individuel conducteur (forfait de 1 000 000)", price: 2100 },
      { id: 49, name: "Individuel conducteur (forfait de 1 000 000)", price: 2100 },
      { id: 27, name: "Individuel conducteur (forfait de 2 000 000)", price: 3400 },
      { id: 39, name: "Individuel conducteur (forfait de 2 000 000)", price: 3400 },
      { id: 50, name: "Individuel conducteur (forfait de 2 000 000)", price: 3400 },
      { id: 40, name: "Sécurité routière – Garantie Personnes Transportées (forfait de 1 000 000)", price: 1400 },
      { id: 51, name: "Sécurité routière – Garantie Personnes Transportées (forfait de 1 000 000)", price: 1400 },
      { id: 41, name: "Sécurité routière – Garantie Personnes Transportées (forfait de 2 000 000)", price: 2800 },
      { id: 52, name: "Sécurité routière – Garantie Personnes Transportées (forfait de 2 000 000)", price: 2800 },
    ],
    useTypes: [
      { name: "Personnel", id: 1 },
      { name: "Taxi", id: 2 },
    ],
    files: [],
    summary: {
      amount: 0,
      avenant: 0,
      taxe: 0,
      fees: 0,
      total: 0,
    },
    puissance: [],
    durations: [],
    surprime: [],
    garuanted: [],
    form: {
      amount: "",
      product_id: 1,
      step: 1,
      data: {
        client_name: "",
        client_firstname: "",
        client_phone: "",
        client_email: "",
        type_engin: "2",
        sale_code: "",
        sale_point: "",
        fuel_id: "",
        power_id: "",
        category_id: 2,
        sub_category_id: "",
        contain_cedeao: false,
        use_type: "",
        semi_remorque: false,
        domage: false,
        duration_of_insurance: "",
        number_of_seats_in_the_vehicle: "",
        name: "",
        email: "",
        address: "",
        phone: "",
        valeur_venal: "",
        valeur_neuve: "",
        person_to_contact: "",
        telephone_number: "",
        vehicle_registration_card: "",
        list_of_guarantees: [],
      },
    },
    comment: {
      message: "",
      uuid: "",
      id: "",
    },
    sending: false,
    comments: [],
    uuid: "",
    id: "",
  }),
  watch: {
    pourcentageReduction(newValue, oldValue) {
      if (newValue.startsWith("0") && newValue.length > 1) {
        this.pourcentageReduction = newValue.replace(/^0+/, "");
      }
    },
    'form.data.duration_of_insurance': function(newValue, oldValue) {
         this.applyLiveCalculation();
    },
    'form.data': {
      handler(newValue, oldValue) {
        if (newValue.use_type && newValue.duration_of_insurance && newValue.power_id) {
            this.applyLiveCalculation();
        }
      },
      deep: true
    }
  },
  mounted() {

    this.getIntermediairesWithSaleCode()
    this.auth = JSON.parse(localStorage.getItem('auth')).user
  },
  methods: {
    getSalePoint() {
      const intermediaire = this.intermediaires.find(item => item.sale_code === this.form.data.sale_code)

      if(intermediaire) {
        this.form.data.sale_point = intermediaire.nom_entreprise ? intermediaire.nom_entreprise : intermediaire.last_name + ' ' + intermediaire.first_name
      }
    },
    toggleGuarantee() {
      this.form.data.contain_cedeao = !this.form.data.contain_cedeao
    },

    applyLiveCalculation() {
      // Évite les 422: ne pas appeler tant que les champs requis ne sont pas renseignés.
      if (
        !this.form?.data?.duration_of_insurance ||
        !this.form?.data?.type_engin ||
        !this.form?.data?.power_id ||
        !this.form?.data?.number_of_seats_in_the_vehicle ||
        !this.form?.data?.valeur_venal ||
        !this.form?.data?.valeur_neuve
      ) {
        return;
      }

      // Moto (type_engin = 2) requiert use_type
      if (String(this.form.data.type_engin) === "2" && !this.form.data.use_type) {
        return;
      }

      axios
        .post(apiV1("subscriptions/auto-calculate"), {
          product_id: 1, // Moto (le produit est le même que auto en DB souvent, ou géré par type_engin)
          type_engin: this.form.data.type_engin,
          category_id: this.form.data.category_id,
          duration_of_insurance: this.form.data.duration_of_insurance,
          power_id: this.form.data.power_id,
          use_type: this.form.data.use_type,
          number_of_seats_in_the_vehicle: this.form.data.number_of_seats_in_the_vehicle,
          contain_cedeao: this.form.data.contain_cedeao,
          list_of_guarantees: this.form.data.list_of_guarantees,
          valeur_venal: this.form.data.valeur_venal,
          valeur_neuve: this.form.data.valeur_neuve,
          pourcentage_reduction: this.form.data.pourcentage_reduction || null,
        })
        .then((response) => {
          if (response.data.status) {
            this.summary.amount = response.data.net_premium;
            this.summary.taxe = response.data.tax;
            this.summary.avenant = response.data.avenant;
            this.summary.fees = response.data.fees || 0;
            this.summary.total = response.data.total;
            this.form.amount = response.data.total;
            if (response.data.prc) {
              this.form.data.prc = response.data.prc;
            }
          }
        })
        .catch((error) => {
          console.error("Live calculation failed:", error);
        });
    },
    getIntermediairesWithSaleCode() {
      axios
        .get(api("intermediaires"))
        .then((response) => {
          this.intermediaires = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    applyReduce() {
      if(this.pourcentageReduction) {
        if(this.pourcentageReduction === 0 || this.pourcentageReduction === '0') {
          this.$toasted.global.error({
            message: "Entrez une valeur suppérieur à 0",
          })
          return
        }

        this.form.data.pourcentage_reduction = this.pourcentageReduction;
        this.applyLiveCalculation();
        this.alreadyReduce = true;

        this.$toasted.global.all({
          message: "la réduction a été appliquée et le prix recalculé par le serveur",
        });
      } else {
        this.$toasted.global.error({
          message: "Entrez une valeur avant de valider",
        })
      }
    },
    sendComment() {
      if (this.comment.message != "") {
        this.sending = false;
        this.comment.uuid = this.uuid;
        this.comment.id = this.id;
        axios.post(api("subscription/add/message"), this.comment);
        this.comment.message = "";
      } else this.sending = true;
    },
    closeModal() {
      this.$document("#comments").modal("hide");
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
    showComments() {
      db.collection(this.uuid)
        .orderBy("createdAt")
        .onSnapshot((querySnapshot) => {
          let comments = [];
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          this.comments = comments;
        });
    },
    checkGaruanted(item, key) {
      if (this.form.data.list_of_guarantees.includes(item.id)) {
        let index = this.form.data.list_of_guarantees.indexOf(item.id);
        this.form.data.list_of_guarantees.splice(index, 1);
        if (item.id == "49") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "50") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "51") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "52") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "38") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "39") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "40") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "41") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "26") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "27") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "25") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "24") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "37") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "36") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "48") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "47") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "19") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "20") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "31") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "32") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "43") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "44") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        }
      } else {
        if (item.id == "49") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "50") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "51") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "27") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "26") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "52") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "38") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "39") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "40") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "41") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "25") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "24") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "37") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "36") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "48") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "47") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "19") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "20") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "31") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "32") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "43") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "44") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        }
        this.form.data.list_of_guarantees.push(item.id);
      }
    },
    getPriceGaruanted(item) {
      const ids = []

      if(!ids.includes(item.id)) return this.$format(Math.round(item.amount))

      if(this.form.data.category_id == 1 || this.form.data.category_id == 2 || this.form.data.category_id == 3 || this.form.data.category_id == 5) {
        if(this.form.data.duration_of_insurance == '1 year') {
          if(item.id == 19) return Math.round(this.form.data.valeur_venal * 0.008)
  
          if(item.id == 20) return Math.round(this.form.data.valeur_venal * 0.0035)
  
          if(item.id == 21) return Math.round(this.form.data.valeur_venal * 0.02)
  
          if(item.id == 22) return 10000
  
          if(item.id == 24) return Math.round(this.form.data.valeur_neuve * 0.01)
          
          if(item.id == 25) return Math.round(this.form.data.valeur_neuve * 0.0245)

          if(item.id == 53) return Math.round(this.form.data.valeur_venal * 0.0035 * 0.05)

          if(item.id == 54) return Math.round(this.form.data.valeur_neuve * 0.0245)
        }
      }

    },
    getGaruanted() {
      axios
        .post(api("assurance-automobile/subscription"), {
          category: this.form.data.category_id,
          state: "garuanted",
        })
        .then((response) => {
          this.loading = false;
          this.garuanted = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    showTooltips(text) {
      this.$document(".tooltips_n").tooltip({
        title: text,
        trigger: "click",
        placement: "top",
      });
    },

    nextStep() {
      if (this.step < 4) this.step++;
      if (this.step === 3) {
        this.$refs.upload.reloadView();
      }
      console.log(this.step)
    },
    prevStep() {
      if (this.step !== 1) this.step--;
      if (this.step === 3) {
        this.$refs.upload.reloadView();
      }
    },
    titleStep() {
      if (this.step === 1 || this.step === 2) {
        return "Informations";
      } else if (this.step === 3) {
        return "Fichiers joints";
      } else return "Résultat";
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
        case 2:
          return "Suivant";
        case 3:
          return "Suivant";
        case 4:
          return "Ajouter au panier";
      }
    },

    saveForLate() {
      if (this.step == "1") {
        this.$toasted.global.error({
          message: "Vous devez completer la première étape",
        });
      } else {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/save-for-late"), this.form)
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La souscription a été enrégistrée",
              });
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },

    saveNegotiated() {
      if (this.step === 3) {
        let loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/negotiated"), this.form)
          .then((response) => {
            if (response.data.status) {
              let content = response.data;
              this.uuid = content.uuid;
              this.id = content.id;
              this.showComments();
              setTimeout(() => {
                this.$document("#comments").modal("show");
                loader.hide();
              });
            } else {
              loader.hide();
              this.$toasted.global.error();
            }
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },
    addBasket() {
      //let carts = localStorage.getItem('carts');
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                this.form.amount = this.summary.total;
                data.push({
                  product: this.form,
                  detail: this.summary,
                  files: this.files,
                  check: true,
                  uuids: this.$uuid(),
                });
                //localStorage.setItem('carts', JSON.stringify(data));
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  location.href = '/pannier'
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    files: this.files,
                    check: true,
                    uuids: this.$uuid(),
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  location.href = '/pannier'
                }, 500);
              }
            }
          })
          .catch(() => {
            loader.hide();
            this.$toasted.global.error({
              message: "Impossible d'ajouter le produit au panier",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          this.form.amount = this.summary.total;
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
          });
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            location.href = '/pannier'
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            location.href = '/pannier'
          }, 500);
        }
      }
    },
    saveAssurance() {
      if (this.step === 4) {
        this.addBasket();
      } else {
        if (this.step === 1) {
          this.loading = true;
          const loader = this.$loading.show({
            container: null,
            canCancel: false,
            color: "#4B4B4B",
            backgroundColor: "#4B4B4B",
            height: 35,
            width: 35,
            loader: "bars",
            opacity: 0.3,
          });
          this.getGaruanted()
          axios
            .post(api("assurances/automobile/save"), this.form)
            .then((response) => {
              this.loading = false;
              if (response.data.status) {
                this.errors = [];
                // Structure unifiée du service centralisé
                this.summary.amount = response.data.amount.net_premium || 0;
                this.summary.taxe = response.data.amount.tax || 0;
                this.summary.avenant = response.data.amount.avenant || 0;
                this.summary.total = response.data.amount.total || 0;
                this.form.amount = response.data.amount.total || 0;

                if(this.step === 1 && response.data.amount.prc) this.form.data.prc = response.data.amount.prc
                
                this.nextStep();
              } else this.$toasted.global.error();
              loader.hide();
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                if (typeof this.errors !== 'object') {
                  this.$toasted.global.error({
                    message: this.errors,
                  });
                }
              }
              this.loading = false;
              loader.hide();
            });
        } 

        else if (this.step === 2) {
          // Tout est déjà calculé en temps réel par applyLiveCalculation
          this.nextStep();
        }
        else {
          this.nextStep();
        }
      }
    },

    getPuissance() {
      if (this.form.data.use_type !== "") {
        this.loading = true;
        //this.zone_section = [];
        axios
          .post(api("assurance-automobile/subscription"), {
            slug: "2-3-roue",
            use: this.form.data.use_type,
            state: "power",
          })
          .then((response) => {
            this.loading = false;
            this.puissance = response.data;
            console.log(this.puissance)
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },

    getDurations() {
      axios
        .post(api("assurance-automobile/subscription"), {
          state: "duration",
        })
        .then((response) => {
          this.loading = false;
          // Ne pas forcer le filtrage sur '1 an' — afficher toutes les durées retournées
          this.durations = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    changeType() {
      this.$emit("changeTypeAuto", 1);
    },
  },
};
</script>

<style scoped lang="scss">
input[type="checkbox"] {
  transform: scale(1.2);
}
.body__form--subscription {
}
.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 150px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
    align-self: center;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}

.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg-text {
  color: #002a85;
}

.section__neg {
  cursor: pointer;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
/*
    .surprime__section{
        display: grid;
        grid-template-columns: 110px 2fr 110px;
        align-items: baseline;
        .surprime__section-two{
            border-bottom: 1px dotted #000000;
        }
        .surprime__section-tree{
            justify-self: end;
            color: #000000;
            font-weight: bold;
        }
        .surprime__section-first{
            color: #6E6B7B;
        }
    }*/
.surprime__section {
  display: flex;
  flex-direction: row;
}
.surprime__section-two {
  flex-grow: 2;
  border-bottom: 1px solid;
}
.surprime__section-tree {
  flex-grow: 0;
}
.grid-item {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  padding: 5px;
}
.chat {
  background-color: #fff;
  padding: 10px;
  height: auto;
  width: 80%;
  border-radius: 5px;
}
.chat-left {
  background: linear-gradient(
    46.62deg,
    #001e5f 0%,
    rgba(0, 30, 95, 0.8) 93.64%
  );
  border-radius: 5px;
  color: #fff;
  text-align: right;
  padding: 10px;
  height: auto;
  width: 80%;
  margin-left: 20%;
}
.error {
  border-color: red !important;
}
.btn-primary {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:hover {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:focus,
.btn-primary.focus {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
  box-shadow: 0 0 0 0.2rem #001e5f !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #001e5f !important;
}
.required {
  color: red;
}
</style>
